import React from "react";
import { Route, Switch } from "react-router-dom";
import PrivateRoute from "../PrivateRoute";

import Cursos from "../pages/Company/Cursos";
import AddCurso from "../pages/CentroFormacion/AddCurso";

import LinkButton from "../utils/LinkButton";

import "../static/css/trainingStyle.css";

export const WrapperFormacion = ({ company }) => {
  let rol = localStorage.getItem("rol");
  let pathComplement = "";
  if (rol === "company") pathComplement = "/company";
  else pathComplement = "/CentroFormacion";

  let url = window.location.pathname;
  let bandtag = true;
  // Match a string that ends with abc, similar to LIKE '%abc'
  if (url.match(/^.*Cursos$/)) {
    /*Match found */
    bandtag = false;
  }
  
  return (
    <div id="training" className="mt-5">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <ul
              className="nav nav-pills mb-3 justify-content-center"
              id="pills-tab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <LinkButton
                  to={pathComplement + "/Formacion/Publica"}
                  className={bandtag === true ? "nav-link active" : "nav-link"}
                  data-bs-toggle="pill"
                  data-bs-target="#pills-home"
                  type="button"
                  role="tab"
                  aria-controls="pills-home"
                  aria-selected="true"
                  id="pills-tab1"
                >
                  Publica una Formación
                </LinkButton>
              </li>
              <li className="nav-item" role="presentation">
                <LinkButton
                  to={pathComplement + "/Formacion/Publica/Cursos"}
                  className={bandtag === true ? "nav-link" : "nav-link active"}
                  id="pills-tab2"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-profile"
                  type="button"
                  role="tab"
                  aria-controls="pills-profile"
                  aria-selected="false"
                >
                  Administrar tus Formaciones
                </LinkButton>
              </li>
            </ul>
            <Route path={pathComplement + "/Formacion/:path?"}>
              <Switch>
                <PrivateRoute
                  path={pathComplement + "/Formacion/Publica"}
                  exact
                >
                  <AddCurso data={company}></AddCurso>
                </PrivateRoute>
                <PrivateRoute
                  path={pathComplement + "/Formacion/Publica/Cursos"}
                  exact
                >
                  <Cursos data={company}></Cursos>
                </PrivateRoute>
              </Switch>
            </Route>
          </div>
        </div>
      </div>
    </div>
  );
};
export default WrapperFormacion;
